export const INTERPOLATION_REGEX = /(?:\:\:)?\{\{.+\}\}/g

export const isInterpolation = value => {
  return !!String(value).match(INTERPOLATION_REGEX)
}
